/* Marelou — scripts du thème (vanilla, sans dépendance) */
(() => {
  const M = window.Marelou || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const fmt = (cents) => {
    const v = cents / 100;
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: Number.isInteger(v) ? 0 : 2 }).format(v);
  };

  /* ---------------- toast ---------------- */
  let toastTimer;
  const toast = (msg) => {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-visible'), 2600);
  };

  /* ---------------- drawers ---------------- */
  let lastFocus = null;
  const openDrawer = (name) => {
    if (name === 'search') return openSearch();
    const d = $(`[data-drawer="${name}"]`); if (!d) return false;
    if (!$('.drawer.is-open') && !$('[data-search-panel].is-open')) lastFocus = document.activeElement;
    $$('.drawer.is-open').forEach((other) => {
      if (other !== d) { other.classList.remove('is-open'); other.setAttribute('aria-hidden', 'true'); }
    });
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const panel = $('.drawer__panel', d); panel && panel.focus({ preventScroll: true });
    return true;
  };
  const closeDrawers = () => {
    $$('.drawer.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('is-locked');
    closeSearch();
    lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const ok = openDrawer(opener.dataset.open);
      if (ok !== false) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawers(); }
    if (e.target.closest('[data-close-search]')) { e.preventDefault(); closeSearch(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------------- header ---------------- */
  const header = $('[data-header]');
  if (header) {
    let wasStuck;
    const onScroll = () => {
      const stuck = window.scrollY > 4;
      if (stuck !== wasStuck) { header.classList.toggle('is-stuck', stuck); wasStuck = stuck; }
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------------- announcement ---------------- */
  const announcementControllers = new Map();
  const initAnnouncements = (root = document) => {
    $$('[data-announce]', root).forEach((ann) => {
      if (announcementControllers.has(ann)) return;
      const msgs = $$('.announce__msg', ann);
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = Math.max(0, msgs.findIndex((msg) => msg.classList.contains('is-active')));
      let timer;
      let transition;
      let hovered = false;
      const select = (next) => {
        msgs.forEach((msg, i) => {
          const active = i === next;
          msg.classList.toggle('is-active', active);
          msg.classList.remove('is-leaving');
          msg.setAttribute('aria-hidden', String(!active));
          msg.inert = !active;
        });
        index = next;
      };
      const stop = () => { clearTimeout(timer); clearTimeout(transition); select(index); };
      const schedule = () => {
        clearTimeout(timer);
        if (msgs.length < 2 || motion.matches || document.hidden || hovered || ann.contains(document.activeElement)) return;
        timer = setTimeout(() => {
          msgs[index].classList.add('is-leaving');
          msgs[index].classList.remove('is-active');
          transition = setTimeout(() => { select((index + 1) % msgs.length); schedule(); }, 320);
        }, 5000);
      };
      const refresh = () => { stop(); schedule(); };
      ann.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') { hovered = true; stop(); } });
      ann.addEventListener('pointerleave', () => { hovered = false; schedule(); });
      ann.addEventListener('focusin', stop);
      ann.addEventListener('focusout', () => { queueMicrotask(schedule); });
      document.addEventListener('visibilitychange', refresh);
      motion.addEventListener('change', refresh);
      select(index);
      schedule();
      announcementControllers.set(ann, () => {
        stop();
        document.removeEventListener('visibilitychange', refresh);
        motion.removeEventListener('change', refresh);
      });
    });
  };
  initAnnouncements();
  document.addEventListener('shopify:section:load', (event) => initAnnouncements(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    announcementControllers.forEach((destroy, ann) => {
      if (event.target.contains(ann)) { destroy(); announcementControllers.delete(ann); }
    });
  });

  /* ---------------- cart ---------------- */
  const refreshCart = async (sectionsHtml, open = true) => {
    let html = sectionsHtml && sectionsHtml['cart-drawer'];
    if (!html) {
      const r = await fetch(`${M.routes.root.replace(/\/$/, '')}/?sections=cart-drawer`);
      html = (await r.json())['cart-drawer'];
    }
    const wrap = document.getElementById('shopify-section-cart-drawer');
    if (wrap && html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.drawer');
      const old = $('.drawer', wrap);
      if (fresh && old) {
        if (old.classList.contains('is-open')) { fresh.classList.add('is-open'); fresh.setAttribute('aria-hidden', 'false'); }
        old.replaceWith(fresh);
      }
    }
    const cart = await (await fetch(`${M.routes.cart}.js`)).json();
    $$('[data-cart-count]').forEach((el) => { el.dataset.count = cart.item_count; el.textContent = cart.item_count || ''; });
    if (open) openDrawer('cart');
    return cart;
  };

  let cartQueue = Promise.resolve();
  const queueCart = (operation) => {
    const next = cartQueue.then(operation, operation);
    cartQueue = next.catch(() => {});
    return next;
  };
  const pendingAdds = new WeakSet();
  const addItems = (items, btn) => {
    if (btn && pendingAdds.has(btn)) return;
    if (btn) { pendingAdds.add(btn); btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    return queueCart(async () => {
    try {
      const r = await fetch(`${M.routes.cartAdd}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || "Impossible d'ajouter ce produit."); return; }
      await refreshCart(data.sections);
    } catch (err) { toast('Connexion interrompue, réessayez.'); }
    finally {
      if (btn) { pendingAdds.delete(btn); btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    }
    });
  };

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.matches('[data-quick-add]')) {
      e.preventDefault();
      addItems([{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }], form.querySelector('button'));
      return;
    }
    if (form.matches('.buy-form')) {
      e.preventDefault();
      const id = Number(form.querySelector('[name="id"]').value);
      const qty = Math.max(1, Number(form.querySelector('[name="quantity"]').value) || 1);
      const items = [{ id, quantity: qty }];
      const scope = form.closest('[data-pdp]') || form.closest('section') || document;
      $$('[data-addon]:checked', scope).forEach((c) => items.push({ id: Number(c.dataset.addon), quantity: 1 }));
      addItems(items, form.querySelector('[data-add-button]'));
    }
  });

  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-add-variant]');
    if (add) { e.preventDefault(); addItems([{ id: Number(add.dataset.addVariant), quantity: 1 }], add); return; }
    const ch = e.target.closest('[data-qty-change]');
    if (ch) { e.preventDefault(); changeLine(ch.dataset.qtyChange, Number(ch.dataset.qty)); }
    const step = e.target.closest('[data-step]');
    if (step) {
      const input = step.parentElement.querySelector('input');
      input.value = Math.max(1, (Number(input.value) || 1) + Number(step.dataset.step));
    }
  });
  document.addEventListener('change', (e) => {
    const q = e.target.closest('[data-qty-input]');
    if (q) changeLine(q.dataset.qtyInput, Math.max(0, Number(q.value) || 0));
  });
  const pendingLines = new Set();
  const changeLine = (key, quantity) => {
    if (pendingLines.has(key)) return;
    pendingLines.add(key);
    const controls = $$('[data-qty-change], [data-qty-input]').filter(el => (el.dataset.qtyChange || el.dataset.qtyInput) === key);
    controls.forEach(el => { el.disabled = true; });
    const panel = $('#CartDrawer .drawer__panel'); panel && panel.setAttribute('aria-busy', 'true');
    return queueCart(async () => {
    try {
      const r = await fetch(`${M.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
      });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Impossible de modifier le panier.'); return; }
      await refreshCart(data.sections, true);
    } catch (err) { toast('Connexion interrompue, réessayez.'); }
    finally {
      pendingLines.delete(key);
      controls.forEach(el => { el.disabled = false; });
      const p = $('#CartDrawer .drawer__panel'); p && p.removeAttribute('aria-busy');
    }
    });
  };
  // le lien panier ouvre le tiroir, sauf sur la page panier
  if (document.body.classList.contains('tpl-cart')) $$('[data-open="cart"]').forEach((a) => a.removeAttribute('data-open'));

  /* ---------------- variant picker ---------------- */
  $$('[data-product-form]').forEach((root) => {
    const variants = JSON.parse(($('[data-variants]', root) || {}).textContent || '[]');
    const scope = root.closest('[data-pdp]') || root.closest('section') || document;
    const idInput = $('[data-variant-id]', root);
    const btn = $('[data-add-button]', root);
    const fieldsets = $$('fieldset.opt', root);
    if (!fieldsets.length) return;

    const selected = () => fieldsets.map((fs) => (fs.querySelector('input:checked') || {}).value);
    const markAvailability = (sel) => {
      fieldsets.forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const test = sel.slice(); test[idx] = inp.value;
          const exists = variants.find((v) => v.options.every((o, k) => o === test[k]));
          const lab = inp.nextElementSibling;
          lab && lab.classList.toggle('is-unavailable', !exists || !exists.available);
        });
      });
    };
    const update = (fromUser) => {
      let sel = selected();
      let v = variants.find((x) => x.options.every((o, k) => o === sel[k]));
      if (!v && fromUser) {
        // combinaison inexistante : on garde la dernière option choisie et on prend la 1re variante compatible
        const last = fromUser.idx;
        v = variants.find((x) => x.options[last] === sel[last] && x.available) || variants.find((x) => x.options[last] === sel[last]);
        if (v) { fieldsets.forEach((fs, k) => { const inp = $$('input', fs).find((i) => i.value === v.options[k]); if (inp) inp.checked = true; }); sel = v.options; }
      }
      fieldsets.forEach((fs, k) => { const l = $('[data-option-label]', fs); if (l) l.textContent = sel[k] || ''; });
      markAvailability(sel);
      if (!v) { btn.disabled = true; $('[data-add-label]', root).textContent = 'Indisponible'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      $('[data-add-label]', root).textContent = v.available ? 'Ajouter au panier' : 'Épuisé pour le moment';
      const addPrice = $('[data-add-price]', root);
      if (M.anniversary) M.anniversary.renderAmount(addPrice, v.price);
      else addPrice.textContent = fmt(v.price);
      $$('[data-price]', scope).filter((el) => !el.dataset.annivProduct || el.dataset.annivProduct === addPrice.dataset.annivProduct).forEach((el) => {
        if (M.anniversary) { M.anniversary.renderPrice(el, v.price, v.compare); return; }
        el.classList.toggle('price--sale', v.compare > v.price);
        el.innerHTML = fmt(v.price) + (v.compare > v.price ? `<s>${fmt(v.compare)}</s>` : '');
      });
      const sp = $('[data-sticky-price]'); if (sp && scope.matches('[data-pdp]')) {
        if (M.anniversary) M.anniversary.renderAmount(sp, v.price);
        else sp.textContent = fmt(v.price);
      }
      const sa = $('[data-sticky-add]'); if (sa && scope.matches('[data-pdp]')) sa.disabled = !v.available;
      if (scope.matches('[data-pdp]')) {
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (v.media && fromUser) goToMedia(v.media);
      }
    };
    fieldsets.forEach((fs, idx) => fs.addEventListener('change', () => update({ idx })));
    markAvailability(selected());
  });

  /* ---------------- gallery ---------------- */
  const gallery = $('[data-gallery]');
  let goToMedia = () => {};
  if (gallery) {
    const track = $('[data-gallery-track]', gallery);
    const items = $$('.gallery__item', track);
    const thumbs = $$('[data-thumb]', gallery);
    const idx = $('[data-gallery-index]', gallery);
    const isSlider = () => window.innerWidth < 990;
    const setActive = (i) => {
      idx && (idx.textContent = i + 1);
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      const th = thumbs[i]; th && th.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };
    track.addEventListener('scroll', () => {
      if (!isSlider()) return;
      const i = Math.round(track.scrollLeft / track.clientWidth); setActive(i);
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = Number(t.dataset.thumb); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setActive(i);
    }));
    goToMedia = (mediaId) => {
      const i = items.findIndex((el) => el.dataset.mediaId === String(mediaId));
      if (i < 0) return;
      if (isSlider()) { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); setActive(i); }
      else if (i > 0) { items[i].scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };
    // arrivée avec ?variant= : afficher l'image de la variante
    const vParam = new URL(window.location.href).searchParams.get('variant');
    if (vParam) {
      const root = $('[data-pdp] [data-product-form]');
      const list = root ? JSON.parse(($('[data-variants]', root) || {}).textContent || '[]') : [];
      const v = list.find((x) => String(x.id) === vParam);
      if (v && v.media && isSlider()) setTimeout(() => goToMedia(v.media), 300);
    }
  }

  /* ---------------- sticky add to cart ---------------- */
  const sticky = $('[data-sticky-buy]');
  const mainBtn = $('[data-pdp] [data-add-button]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(mainBtn);
    $('[data-sticky-add]', sticky).addEventListener('click', () => mainBtn.closest('form').requestSubmit());
  }

  /* ---------------- estimation de livraison ---------------- */
  const eta = $('[data-eta-range]');
  if (eta && M.delivery) {
    const addBusinessDays = (date, n) => {
      const d = new Date(date);
      while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; }
      return d;
    };
    const now = new Date();
    let start = now;
    if (now.getHours() >= (M.delivery.cutoff || 13) || now.getDay() === 0 || now.getDay() === 6) start = addBusinessDays(now, 1);
    const a = addBusinessDays(start, Number(M.delivery.min) || 3);
    const b = addBusinessDays(start, Number(M.delivery.max) || 6);
    const f = (d) => d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
    eta.textContent = `entre le ${f(a)} et le ${f(b)}`;
  }

  /* ---------------- onglets (toise par âge) ---------------- */
  $$('[data-tabs]').forEach((wrap) => {
    const tabs = $$('[role="tab"]', wrap);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); const p = document.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = t !== tab; });
      revealAll(wrap);
    }));
  });

  /* ---------------- collection : tri et filtres ---------------- */
  const sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', () => {
    const url = new URL(window.location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });
  const applyBtn = $('[data-apply-filters]');
  if (applyBtn) applyBtn.addEventListener('click', () => {
    const form = $('[data-filter-form]');
    const params = new URLSearchParams();
    new FormData(form).forEach((val, key) => {
      if (val === '') return;
      if (key.startsWith('filter.v.price')) { params.append(key, String(val).replace(',', '.')); return; }
      params.append(key, val);
    });
    window.location.href = `${form.getAttribute('action')}?${params.toString()}`;
  });

  /* ---------------- recherche prédictive ---------------- */
  const panel = $('[data-search-panel]');
  const input = panel && $('[data-search-input]', panel);
  const results = panel && $('[data-search-results]', panel);
  function openSearch() {
    if (!panel) return false;
    lastFocus = document.activeElement;
    panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    clearTimeout(searchFocusTimer);
    searchFocusTimer = setTimeout(() => input && input.focus({ preventScroll: true }), 120);
    return true;
  }
  function closeSearch() {
    const wasOpen = panel && panel.classList.contains('is-open');
    if (panel) { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); }
    clearTimeout(searchFocusTimer);
    clearTimeout(sTimer);
    searchRequest?.abort();
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (wasOpen) lastFocus?.focus({ preventScroll: true });
  }
  let sTimer, searchRequest, searchFocusTimer;
  input && input.addEventListener('input', () => {
    clearTimeout(sTimer);
    searchRequest?.abort();
    const q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    sTimer = setTimeout(async () => {
      const request = new AbortController();
      searchRequest = request;
      try {
        const r = await fetch(`${M.routes.predictiveSearch}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`, { signal: request.signal });
        if (!r.ok) return;
        const data = await r.json();
        if (request.signal.aborted || input.value.trim() !== q) return;
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) { results.innerHTML = `<p class="t-muted">Rien pour « ${q.replace(/</g, '&lt;')} ». Essayez « tour », « lit » ou « chaise ».</p>`; return; }
        results.innerHTML = `<div class="search-results__grid">${products.map((p) => `
          <a class="sr-item" href="${p.url}">
            ${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=400" alt="" loading="lazy">` : ''}
            <span><strong>${p.title}</strong><br><span class="t-muted">${fmt(M.anniversary ? M.anniversary.amount(Math.round(parseFloat(p.price) * 100), p.id) : Math.round(parseFloat(p.price) * 100))}</span></span>
          </a>`).join('')}</div>`;
      } catch (err) { /* silencieux */ }
    }, 220);
  });

  /* ---------------- apparition au scroll ---------------- */
  const revealAll = (root = document) => $$('.reveal:not(.is-in)', root).forEach((el) => io ? io.observe(el) : el.classList.add('is-in'));
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  revealAll();
})();



